<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle
    [title]="userType == 'fleet' ? 'Drivers' : 'Customers'"
    [breadcrumbItems]="breadCrumbItems"
  ></app-pagetitle>
  <div class="d-flex justify-content-end">
    <mat-form-field class="col-12 col-sm-6 col-md-4 p-0 m-0">
      <mat-label>Branch</mat-label>
      <mat-select
        [ngModel]="dashboardService.selectedBranch.branchName"
        (selectionChange)="onBranchSelect($event.value)"
      >
        <mat-option [value]="dashboardService.myBranch">{{
          dashboardService.myBranch.branchName
        }}</mat-option>
        <mat-option
          *ngFor="let branch of dashboardService.branches"
          [value]="branch"
          >{{ branch.branchName }} ({{ branch.userName }})
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between">
            <!--  -->
            <div>
              <a
                href="javascript:void(0);"
                class="btn btn-success mb-2"
                (click)="
                  this.customerAddForm.get('mobileNumber').setValue('');
                  openModal(content)
                "
              >
                <i class="mdi mdi-plus-thick mr-2"></i> Add
                {{ userType == "fleet" ? "Driver" : "Customer" }}
              </a>
              <a
                *ngIf="userType == 'fleet'"
                href="javascript:void(0);"
                class="btn btn-success mb-2 ml-2"
                (click)="openModal(settingsModal)"
              >
                <i class="mdi mdi-cog mr-2"></i> Settings
              </a>
            </div>
            <div class="">
              <label class="sr-only" for="inlineFormInputGroup">Search</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="fa fa-search"></i>
                  </div>
                </div>
                <input
                  type="text"
                  class="form-control"
                  id="inlineFormInputGroup"
                  [placeholder]="
                    userType == 'fleet'
                      ? 'Search Driver...'
                      : 'Search Customer...'
                  "
                  (input)="onCustomerSearch($event.target.value)"
                />
              </div>
            </div>
          </div>
          <div class="table-responsive mt-3">
            <table
              class="table table-centered datatable dt-responsive nowrap"
              style="border-collapse: collapse; border-spacing: 0; width: 100%"
            >
              <thead class="thead-light">
                <tr>
                  <th>S.No.</th>
                  <th>Name</th>
                  <!-- <th class="col-3">Email</th> -->
                  <th>Phone</th>
                  <th>Level</th>
                  <th>Safety Score</th>
                  <th>Fuel Savings</th>
                  <th>Wallet</th>
                  <!-- <th *ngIf="userType == 'fleet'">Risk Status</th> -->
                  <!-- <th>Risk Analysis</th> -->
                  <th class="col-1">Verified</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of customers; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    {{ item.customer ? item.customer.userFullName : "-" }}
                  </td>
                  <!-- <td>{{ item.customer ? item.customer.userEmail : "-" }}</td> -->
                  <td>{{ item.userPhoneNumber }}</td>
                  <td>{{ item.userGameLevel }}</td>
                  <td>{{ item.safetyScore | number : "1.2-2" }}%</td>
                  <td>{{ item.fuelSavings | number : "1.2-2" }}</td>
                  <td>{{ item.walletAmount | number : "1.2-2" }}</td>

                  <!-- <td *ngIf="userType == 'fleet'">{{ item.riskStatus }}</td> -->
                  <!-- <td *ngIf="userType == 'fleet'">
                    <a
                      *ngIf="item.verified"
                      href="javascript:void(8)"
                      class="text-primary"
                      [routerLink]="[item.customer.userId, 'risk-analysis']"
                      [queryParams]="{
                        customerName: item.customer.userFullName
                      }"
                      >View Analysis</a
                    >
                  </td> -->
                  <td class="col-1">
                    <span class="text-success" *ngIf="item.verified"
                      ><i class="fa fa-check"></i
                    ></span>
                    <span class="text-danger" *ngIf="!item.verified"
                      ><i class="fa fa-times"></i
                    ></span>
                  </td>
                  <td>
                    <button
                      mat-button
                      (click)="onResendCodeClick(item)"
                      *ngIf="!item.verified"
                    >
                      <a href="javascript:void(0)">Resend Code</a>
                    </button>
                    <div
                      class="dropdown mt-4 mt-sm-0"
                      ngbDropdown
                      *ngIf="item.verified"
                    >
                      <a class="btn btn-light" ngbDropdownToggle>
                        Menu <i class="mdi"></i>
                      </a>
                      <div class="dropdown-menu" ngbDropdownMenu>
                        <a
                          href="javascript:void(8)"
                          class="dropdown-item p-2"
                          [routerLink]="[item.customer.userId, 'risk-analysis']"
                          [queryParams]="{
                            customerName: item.customer.userFullName
                          }"
                          >View Performance</a
                        >
                        <a
                          href="javascript:void(8)"
                          class="dropdown-item p-2"
                          [routerLink]="[item.customer.userId, 'fuel-expenses']"
                          [queryParams]="{
                            customerName: item.customer.userFullName
                          }"
                          >Fuel Expenses</a
                        >
                        <a
                          class="dropdown-item p-2"
                          href="javascript: void(0);"
                          *ngIf="item.verified"
                          [routerLink]="[item.customer.userId, 'vehicles']"
                          [queryParams]="{
                            customerName: item.customer.userFullName
                          }"
                          >Vehicles</a
                        >
                        <!-- <a
                          class="dropdown-item p-2"
                          href="javascript: void(0);"
                          *ngIf="item.verified"
                          [routerLink]="[item.customer.userId, 'trips']"
                          [queryParams]="{
                            customerName: item.customer.userFullName
                          }"
                          >Trips</a
                        > -->
                        <button
                          class="dropdown-item p-2"
                          (click)="onDeviceStatusClick(item)"
                        >
                          Device Status
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <mat-paginator
              (page)="pageEvent = getServerData($event)"
              [length]="totalRecords"
              [pageSize]="customerSearch.size"
              [pageSizeOptions]="[10, 20, 50, 100]"
              showFirstLastButtons
            ></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Contacts model  -->
<ng-template #content role="document" let-modal="close">
  <div class="modal-header pb-0 mb-0">
    <h3 class="modal-title">
      {{ userType == "fleet" ? "Add Driver" : "Add Customer" }}
    </h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="addCustomer()" [formGroup]="customerAddForm">
        <div class="form-group">
          <label>Phone </label>
          <input
            class="form-control"
            placeholder="Enter phone number"
            formControlName="mobileNumber"
            [ngClass]="{ 'is-invalid': submitted && form.mobileNumber.errors }"
          />
          <div
            *ngIf="form.mobileNumber.touched && form.mobileNumber.errors"
            class="invalid-feedback"
          >
            <span *ngIf="form.mobileNumber.errors.required"
              >Phone is mandatory.</span
            >
            <span *ngIf="form.mobileNumber.errors.minlength"
              >Phone number must be 10 characters.</span
            >
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-danger ml-1 mr-2"
            (click)="modal('close click')"
          >
            Cancel
          </button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<!-- Settings model  -->
<ng-template #settingsModal role="document" let-modal="close">
  <div class="modal-header pb-0 mb-0">
    <h3 class="modal-title">Performance based driver reward program</h3>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form
        [formGroup]="gameLevelsForm"
        (ngSubmit)="onGameLevelConfigsFormSumit()"
      >
        <div formArrayName="gameLevels">
          <div
            *ngFor="
              let level of gameLevelsForm.get('gameLevels')['controls'];
              let i = index
            "
          >
            <div [formGroupName]="i">
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">{{
                  level.get("levelName").value
                }}</label>
                <div class="col-sm-10">
                  <div class="row">
                    <div class="col-sm-6">
                      <label>Commission Percentage</label>
                      <input
                        class="form-control"
                        type="number"
                        formControlName="commissionPercent"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label>SafeKm Required For Upgrade</label>
                      <input
                        [readOnly]="
                          gameLevelsForm.get('gameLevels').value[i]
                            .nextLevelUpdateSafeKmsPercent
                        "
                        class="form-control"
                        type="number"
                        formControlName="safeKmsRequiredForUpgrade"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <label>Next Level SafeKm Percentage</label>
                      <input
                        [readOnly]="
                          gameLevelsForm.get('gameLevels').value[i]
                            .safeKmsRequiredForUpgrade
                        "
                        class="form-control"
                        type="number"
                        formControlName="nextLevelUpdateSafeKmsPercent"
                      />
                    </div>
                    <div class="col-sm-6">
                      <label>Days Required for Upgrade</label>
                      <input
                        class="form-control"
                        type="number"
                        formControlName="noOfDays"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <button
            type="button"
            class="btn btn-danger ml-1 mr-2"
            (click)="modal('close click')"
          >
            Cancel
          </button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
